'use client';

import { motion, useScroll, useTransform } from 'framer-motion';
import Image from 'next/image';
import { useRef } from 'react';

// Import all artist images
import artist0 from '@/components/static/artists/artist_0.jpg';
import artist1 from '@/components/static/artists/artist_1.jpg';
import artist2 from '@/components/static/artists/artist_2.jpg';
import artist3 from '@/components/static/artists/artist_3.jpg';
import artist4 from '@/components/static/artists/artist_4.jpg';
import artist5 from '@/components/static/artists/artist_5.jpg';
import artist6 from '@/components/static/artists/artist_6.jpg';
import artist7 from '@/components/static/artists/artist_7.jpg';
import artist8 from '@/components/static/artists/artist_8.jpg';
import artist9 from '@/components/static/artists/artist_9.jpg';
import artist10 from '@/components/static/artists/artist_10.jpg';
import artist11 from '@/components/static/artists/artist_11.jpg';
import artist12 from '@/components/static/artists/artist_12.jpg';
import artist13 from '@/components/static/artists/artist_13.jpg';
import artist14 from '@/components/static/artists/artist_14.jpg';

// Define artist images with imported images
const artistRows = [[artist0, artist1, artist2, artist3, artist4, artist5], [artist6, artist7, artist8, artist9, artist10, artist11], [artist12, artist13, artist14, artist0, artist1, artist2]];
export function ArtistsParallax() {
  const containerRef = useRef<HTMLDivElement>(null);
  const {
    scrollYProgress
  } = useScroll({
    target: containerRef,
    offset: ['start end', 'end start']
  });
  const x_even = useTransform(scrollYProgress, [0, 1], ['0%', '-50%']);
  const x_odd = useTransform(scrollYProgress, [0, 1], ['-50%', '0%']);
  return <div ref={containerRef} className="relative h-[30vh] md:h-[40vh] lg:h-[50vh] w-screen overflow-hidden" data-sentry-component="ArtistsParallax" data-sentry-source-file="artists-parallax.tsx">
      <div className="flex flex-col gap-4 absolute w-full h-full">
        {artistRows.map((row, rowIndex) => <motion.div key={rowIndex} className="flex gap-4 md:gap-4 min-w-max" style={{
        x: rowIndex % 2 === 0 ? x_even : x_odd
      }}>
            {/* Single row of images that repeats 3 times */}
            {[0, 1, 2, 3].map(setIndex => <div key={setIndex} className="flex gap-4 md:gap-4 h-full">
                {row.map((image, imageIndex) => <motion.div key={`${setIndex}-${imageIndex}`} initial={{
            opacity: 1,
            scale: 1
          }} transition={{
            duration: 0.5,
            delay: imageIndex * 0.1,
            ease: 'easeOut'
          }} whileHover={{
            scale: 1.1
          }} className="relative w-16 h-16 md:w-24 md:h-24 lg:w-32 lg:h-32 rounded-lg overflow-hidden shrink-0">
                    <Image src={image} alt={`Artist ${rowIndex * 6 + imageIndex + 1}`} fill placeholder="blur" className="object-cover" sizes="(max-width: 768px) 64px, (max-width: 1024px) 96px, 128px" />
                    <motion.div className="absolute inset-0 ring-1 ring-white/10 hover:ring-white/30 transition-all duration-300 rounded-lg" whileHover={{
              opacity: 0
            }} />
                  </motion.div>)}
              </div>)}
          </motion.div>)}
      </div>

      {/* Gradient overlays */}
      <div className="absolute left-0 top-0 bottom-0 w-32 md:w-64 lg:w-96 bg-gradient-to-r from-background to-transparent z-10" />
      <div className="absolute right-0 top-0 bottom-0 w-32 md:w-64 lg:w-96 bg-gradient-to-l from-background to-transparent z-10" />
    </div>;
}